import { FC } from 'react'
import type { CollapseButtonProps } from './types'
import { Typography } from '@sylveraio/design-system'
import clsx from 'clsx'
import ChevronRightDouble from '@sylveraio/untitled-ui-icons-react/build/esm/ChevronRightDouble'

export const CollapseButton: FC<CollapseButtonProps> = ({
  testId = 'collapse-button',
  textClassName,
  onClick,
  collapsed,
  title,
}) => (
  <button
    data-testid={testId}
    onClick={onClick}
    className="flex h-10 w-full cursor-pointer items-center gap-x-3 border-l-4 border-transparent px-3 text-default hover:bg-default-hover"
  >
    <span
      className={clsx(
        'transform transition-transform duration-500 h-5 w-5 shrink-0',
        {
          'rotate-180': !collapsed,
        },
      )}
    >
      <ChevronRightDouble />
    </span>

    <Typography
      size="sm"
      weight="semibold"
      className={clsx(
        'text-left text-inherit whitespace-nowrap',
        textClassName,
      )}
    >
      {title}
    </Typography>
  </button>
)

export default CollapseButton
